import { Component, Input, OnInit } from '@angular/core';
import { WhatsappTemplateScenarioDependency } from '../../shared/models/whatsapp-template-scenario-dependency.model';
import { Observable } from 'rxjs';
import { WhatsappTemplatesService } from '../../whatsapp-templates.service';
import { WhatsappTemplate } from '../../shared';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { BasicService } from 'src/app/shared/services/basic.service';

@Component({
  selector: 'app-whatsapp-template-scenarios-dependencies',
  templateUrl: './whatsapp-template-scenarios-dependencies.component.html',
  styleUrls: ['./whatsapp-template-scenarios-dependencies.component.scss'],
})
export class WhatsappTemplateScenariosDependenciesComponent implements OnInit {
  @Input() template: WhatsappTemplate;

  scenariosDependencies$: Observable<WhatsappTemplateScenarioDependency[]>;
  scenarioListUrl;

  constructor(
    private whatsappTemplatesService: WhatsappTemplatesService,
    alcmeonContextService: AlcmeonContextService,
    basicService: BasicService
  ) {
    const flavor = alcmeonContextService.isOnlyMarketingCompany() ? 'campaign-scenarios' : 'quick-replies';
    const path = `/#/${alcmeonContextService.companyId}/fuse/parameters/all-accounts/${flavor}`;
    this.scenarioListUrl = basicService.fullURLForRoutePath(path);
  }

  ngOnInit(): void {
    this.scenariosDependencies$ = this.whatsappTemplatesService.findTemplateUsageDependencies(
      this.template.metadata.site_id,
      this.template.metadata.name
    );
  }
}
